import { Link } from "react-router-dom";

// logo-mark.png = emblem + "2Voto" wordmark in WHITE on transparent (dark-mode logo).
export default function Logo({ light = false, className = "" }) {
  if (light) {
    // On dark backgrounds (e.g. footer): render directly.
    return (
      <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-link">
        <img src="/logo-mark.png" alt="2Voto — Tu voz después de votar." className="h-9 w-auto" />
      </Link>
    );
  }
  // On light backgrounds (e.g. navbar): wrap in a navy chip so the white logo reads.
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-link">
      <span className="inline-flex items-center bg-slate-900 rounded-xl px-3 py-2">
        <img src="/logo-mark.png" alt="2Voto — Tu voz después de votar." className="h-6 w-auto" />
      </span>
    </Link>
  );
}
